document.addEventListener('click', function(e) {
  const btn = e.target.closest('.boost-sd__button--quick-view');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const productItem = btn.closest('.boost-sd__product-item');
  if (!productItem) return;

  const productData = JSON.parse(productItem.getAttribute('data-product'));
  if (productData && productData.handle) {
    window.location.href = '/products/' + productData.handle;
  }
});